import styled from "styled-components";

export const DropDownContainer = styled("div")`
  width:100%;
  margin: 0 auto;
  position: relative;

`;

export const DropDownHeader = styled("div")`
  padding-top: 19px;
  padding-bottom: 17px;
  padding-left: 24px;
  width: 100%;
  height: 48px;
  background: #fff;
  border-radius: 4px;
  color:black;
  font-size: 14px;
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
img{
    position: absolute;
    right: 23.92px;
    top: 40%;
  }

`;

export const DropDownListContainer = styled("div")`

`;

export const DropDownList = styled("ul")`
  padding: 0;
  margin: 0;
  background: #ffffff;
  border:1px solid #e5e5e5;
  box-sizing: border-box;
  color:black;
  font-size: 1.3rem;
  font-weight: 500;
  margin-top: 7px;
  position: absolute;
  top:54px;
  width: 100%;
  z-index: 9;
  &:first-child {
    padding-top: 0.8em;
  }
 
`;


export const ListItem = styled("li")`
  list-style: none;
  padding-left: 30px;
  width: 100%;
  height: 53px;
  display: flex;
  align-items: center;
  color: ${(props) => (props.textColor)};
  &:hover{
    background-color: #E5E5E5;
    cursor: pointer;
  }
`;
